import type { HostInfo } from '~/use-cases/types/HostInfo';
import { LoadLikedUnitsUseCase } from './company-unit-listing/loadLikedUnitsUseCase';
import { LoadCompanyInfoUseCase } from './companyInfo/loadCompanyInfoUseCase';
import { MagicUseCase } from './magicUseCase';

export class InitializeAppUseCase extends MagicUseCase<HostInfo> {
  protected async runLogic(host: HostInfo) {
    await new LoadCompanyInfoUseCase().execute(host);
    await new LoadLikedUnitsUseCase().execute();
  }
}
